import llmHostPolicy from "../../shared/llm-host-policy.json";

export const LLM_ALLOWED_UPSTREAM_HOSTS = new Set(
  llmHostPolicy.shared.allowedHosts,
);

export const LLM_ALLOWED_UPSTREAM_HOST_SUFFIXES =
  llmHostPolicy.shared.allowedHostSuffixes;

export const LLM_BLOCKED_UPSTREAM_HOSTS = new Set(
  llmHostPolicy.shared.blockedHosts,
);

export const LLM_GAME_BLOCKED_BY_UPSTREAM_HOSTS = new Set(
  llmHostPolicy.mortalOnly.blockedByUpstreamHosts,
);

export function getLlmUpstreamHostname(rawUrl: string): string | null {
  try {
    return new URL(rawUrl.trim()).hostname.toLowerCase();
  } catch {
    return null;
  }
}

export function isAllowedLlmUpstreamHostname(hostname: string): boolean {
  const normalizedHostname = hostname.toLowerCase();
  return (
    !isBlockedLlmUpstreamHostname(normalizedHostname) &&
    (LLM_ALLOWED_UPSTREAM_HOSTS.has(normalizedHostname) ||
      LLM_ALLOWED_UPSTREAM_HOST_SUFFIXES.some((suffix) =>
        normalizedHostname.endsWith(suffix),
      ))
  );
}

export function isAllowedLlmUpstreamUrl(rawUrl: string): boolean {
  const hostname = getLlmUpstreamHostname(rawUrl);
  return hostname !== null && isAllowedLlmUpstreamHostname(hostname);
}

export function isBlockedLlmUpstreamHostname(hostname: string): boolean {
  const normalizedHostname = hostname.toLowerCase();
  return (
    LLM_BLOCKED_UPSTREAM_HOSTS.has(normalizedHostname) ||
    LLM_GAME_BLOCKED_BY_UPSTREAM_HOSTS.has(normalizedHostname)
  );
}

export function isBlockedLlmUpstreamUrl(rawUrl: string): boolean {
  const hostname = getLlmUpstreamHostname(rawUrl);
  return hostname !== null && isBlockedLlmUpstreamHostname(hostname);
}

export function isLlmUpstreamBlockedByThisGameHostname(
  hostname: string,
): boolean {
  return LLM_GAME_BLOCKED_BY_UPSTREAM_HOSTS.has(hostname.toLowerCase());
}
